import * as actions from './actions';
import * as getters from './getters';
import CustomersState from './state';

export { actions, getters };
export default CustomersState;
